module.exports = __webpack_public_path__ + "img/indu_10.457d95d7.png";